module.exports = __webpack_public_path__ + "src/app/_content/imgs/icons/MOT/check-solid.svg?e597acabaa68ed548f509cddfb1ab741";